import React, { useState } from 'react';
import { Box, Button, Grid } from '@mui/material';
import DynamicFormFieldsList from '../Leads/DynamicFormFields/List.tsx';
import LoadingWrapper from '../Shared/LoadingWrapper/index.jsx';
import { ConstantActions } from '../../Services/_actions/constant.actions.js';
import { globalpermissions } from '../../Services/Permission.js';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';


const DetailsSection = ({
  formDataLoading,
  dynamicFormData,
  loggedInUser,
  handleFieldChange,
  fieldErrors,
  formEnable,
  userDetailByNumber,
  userDetails,
  isLoading,
  validateFormData,
  editForms,
  leadFormTemplate,
  setShowQuickTempModal,
  setDispositionModalShow,
  showNotepad,
  setShowNotepad,
  showChatBox, 
  setShowChatBox, 
}) => {
    const constantActions = ConstantActions();
  return (
    <Box>
                  <Grid item>
                    <Box
                      className="lead-web-form-btns btns-responsive"
                      sx={{
                        display: 'flex',
                        justifyContent: 'left',
                        gap: '15px',
                        // padding: '10px 0',
                        alignItems: 'center',
                        mb: '5px',
                      }}
                    >
                      {!showNotepad && (
                        <>
                          <Button
                            variant="contained"
                            size="small"
                            onClick={(e) => {
                              validateFormData();
                            }}
                            disabled={isLoading}
                          >
                            {isLoading ? 'Saving...' : ' Save'}
                          </Button>
                          <Button
                            variant="contained"
                            size="small"
                            onClick={(e) => {
                              editForms();
                            }}
                          >
                            Edit
                          </Button>
                        </>
                      )}
                      {constantActions.userHasPermission([
                        globalpermissions?.leadFormPage?.viewDisposition,
                      ]) && (
                          <Button
                            variant="contained"
                            size="small"
                            sx={{ minWidth: 'auto' }}
                            onClick={() => setDispositionModalShow(true)}
                          >
                            Disposition
                          </Button>
                        )}
                      <Button
                        variant="contained"
                        size="small"
                        sx={{ minWidth: 'auto' }}
                        title="Go to Lead dashboard"
                        onClick={() => {
                          const leadWebFormData = JSON.parse(localStorage.getItem('leadWebFormData')) || {};
                          if (
                            leadWebFormData?.campaign?.proposal_id &&
                            leadWebFormData?.webForm?.leads_form_id
                          ) {
                            window.open(
                              `/r/records/v1`,
                              // `/r/records/details/${leadWebFormData?.campaign?.proposal_id}/${leadWebFormData?.webForm?.leads_form_id}`,
                              '_blank'
                            );
                          }
                        }}
                      >
                        View Lead
                      </Button>
                      <Button
                        variant="contained"
                        size="small"
                        onClick={(e) => {
                          setShowQuickTempModal(true);
                        }}
                        disabled={!leadFormTemplate?.length}
                      >
                        {' '}
                        Quick Template
                      </Button>
                      <Box className="button-row" xs={1} md={1}>
                        <span
                          style={{ cursor: 'pointer' }}
                          onClick={(e) => {
                            setShowChatBox(false);
                            setShowNotepad(!showNotepad);
                          }}
                        >
                          {!showNotepad && <EditOutlinedIcon fontSize="small" />}
                        </span>
                      </Box>{' '}
                    </Box>
                  </Grid>
                  {/* <Row>{formDataLoading ? <LoadingWrapper /> : <DynamicForm />}</Row> */}
                  <Box
                    sx={{ overflowY: 'auto',
                      // overflowY: 'scroll',
                      height: 'calc(100vh - 170px) !important',
                      // '&::-webkit-scrollbar': { display: 'none' },
                      // scrollbarWidth: 'none',
                      // msOverflowStyle: 'none',
                    }}
                  >
                    {formDataLoading ? (
                      <LoadingWrapper />
                    ) : (
                      <DynamicFormFieldsList
                        data={dynamicFormData || {}}
                        userId={loggedInUser?.id}
                        onChange={handleFieldChange}
                        fieldErrors={fieldErrors}
                        disabled={formEnable}
                        phoneNumber={userDetailByNumber?.phone_number || userDetails?.phone_number}
                        gridSize={showNotepad ? 12 : 4}
                      />
                    )}
                  </Box>
                  {showNotepad && (
                    <Grid>
                      <Grid item sx={{ my: 1 }}>
                        <Box
                          className="lead-web-form-btns btns-responsive"
                          sx={{ display: 'flex', justifyContent: 'right', gap: 1 }}
                        >
                          <Button
                            variant="outlined"
                            size="small"
                            onClick={(e) => {
                              editForms();
                            }}
                          >
                            Edit
                          </Button>
                          <Button
                            variant="contained"
                            size="small"
                            onClick={(e) => {
                              validateFormData();
                            }}
                            disabled={isLoading}
                          >
                            {isLoading ? 'Saving...' : ' Save'}
                          </Button>
                        </Box>
                      </Grid>
                    </Grid>
                  )}
                {/* </Grid> */}
                </Box>
  );
};
export default DetailsSection;
